<template>
  <div id="areaTree">
    <div class="box-title">
      <a>组织结构<i class="fa  fa-refresh" @click="freshArea"></i></a>
    </div>
    <div class="tree-box">
      <div class="zTreeDemoBackground left">
        <ul id="treeDemo" class="ztree"></ul>
      </div>
    </div>
    <div class="form-footer">
      <xr-button type="primary" @click="getSelectedValue">确定</xr-button>
      <xr-button type="default" @click="handleCloseDialog">取消</xr-button>
    </div>
  </div>
</template>

<script>
  import '../../../../../static/js/jquery-3.7.1'
  import "../../../../../plugins/zTree/js/jquery.ztree.core.min.js";
  import "../../../../../plugins/zTree/js/jquery.ztree.excheck.min.js";

    export default {
        name: "pageSelectOrg",
        data (){
          return {
            ids: '',
            setting:{
              check:{
                enable: true,
                chkStyle: "checkbox",
                chkboxType: { "Y": "", "N": "" }
              },
              data:{
                simpleData:{
                  enable: true,
                  idKey: "id",
                  pIdKey: "p_id",
                  rootPId: 0
                }
              },
              callback: {
                onClick: this.zTreeOnClick
              }
            },
            zNodes: [],
            treeObj: new Object(),
          }
        },
        components: {
        },
        methods: {
          init(ids) {
            this.ids = ids
            this.initDeptTree();  //初始化部门树
          },
          //初始化部门树
          initDeptTree: function(){
            return this.request({
              method:'post',
              url:'/web/service',
              params:{
                'method':'tCoreOrg_getZtreeData'
              }
            }).then((response) =>{          //这里使用了ES6的语法   //请求成功返回的数据
              if (response.code === 0) {
                let list = response.rows;
                if(list == null || list == '' || list == undefined || list.length < 0){
                  return false;
                }
                //循环遍历，根据部门级别显示图标
                for(let i = 0 ; i < list.length ; i ++){
                  if(list[i].dept_level == '1'){
                    // list[i].icon = require('../../../../static/img/web.png');
                  }else if(list[i].dept_level == '3'){
                    // list[i].icon = require('../../../../static/img/agent.png');
                  }else if(list[i].dept_level == '4'){
                    // list[i].icon = require('../../../../static/img/business.png');
                  }
                }

                if(this.ids != ''){
                  let ids = ',' + this.ids + ',';
                  for (let i = 0; i < list.length; i++) {
                    if(ids.indexOf(',' + list[i].id + ',') != -1){
                      list[i]['checked'] = true;
                    }
                  }
                }

                console.log('+++++++++++++');
                console.log(list);


                this.zNodes = list;

                this.treeObj = $.fn.zTree.init($("#treeDemo"), this.setting, this.zNodes);
                //默认展开所有节点
                this.treeObj.expandAll(true);
                //根据节点加载右侧的数据table
                // this.$emit('getData',nodes[0].id)

              }
            })
          },
          zTreeOnClick:function(event, treeId, treeNode){
            if(treeNode.id != null && treeNode.id != '' && treeNode.id != undefined){

            }
          },
          freshArea:function(){
            $.fn.zTree.init($("#treeDemo"), this.setting, this.zNodes);
          },
          //关闭窗口
          handleCloseDialog(){
            this.dialogVisible = false;
            this.$emit('cancelMethod');
          },
          //获取选中的值
          getSelectedValue(){
            // 假设你已经初始化了ZTree，并且有一个名为"treeId"的树
            let treeObj = $.fn.zTree.getZTreeObj("treeDemo");
            // 获取所有选中的节点
            let checkedNodes = treeObj.getCheckedNodes(true);
            let id = "";
            let name = "";
            // 打印选中的节点
            checkedNodes.forEach(function(node) {
              if(id == ''){
                id += node.id;
                name += node.name;
              }else{
                id += ','  + node.id;
                name += ','  + node.name;
              }
            });
            if(id == ''){
              alert('请选择！');
              return false;
            }
            this.$emit('confirmMethod', id, name);
          }
        }
    }
</script>

<style>
  @import '../../../../../plugins/zTree/css/zTreeStyle/zTreeStyle.css';
  #areaTree{
    width: 95%;
    margin: 0px auto;
    border:1px solid #e5e5e5;
    border-radius: 4px;
    overflow: hidden;
  }
  .box-title{
    border-radius: 3px 3px 0 0;
    background-color: #f5f5f5;
  }
  .box-title a{
    color: #2fa4e7;
    text-decoration: none;font-size:14px;
    display: block;
    padding: 8px 15px;cursor: pointer;
  }
  .box-title .fa{
    float:right;line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageSelect/core/org/orgMultiplePageSelect.vue